import axios from "axios";
import Cookies from "js-cookie";
import config from "../../config";

const Endpoint1 = "/api/obtenerIndicadoresProyectos";
const Endpoint2 = "/api/asignarIndicadoresProyectos";
const Endpoint3 = "/api/obtenerIndicadoresAsignados";
const Endpoint4 = "/api/avancesIndicadores";
const Endpoint5 = "/api/eliminarIndicador";
const Endpoint6 = "/api/repositorioPoSostenibilidad";

// Crear instancia de Axios con configuración base
const api = axios.create({
  baseURL: config.baseUrl,
});

// Interceptor para añadir token JWT si existe
api.interceptors.request.use(
  (config) => {
    const token = Cookies.get("token");
    if (token) {
      config.headers["Authorization"] = `Bearer ${token}`;
    }
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

/**
 * Obtener listado de indicadores disponibles para asignar a proyectos
 */
const getIndicadoresProyectos = async () => {
  try {
    const response = await api.get(Endpoint1);

    return {
      status: response.status,
      data: response.data.data, // ajusta según estructura real
    };
  } catch (error) {
    console.error("Error fetching indicadores:", error);
    return {
      status: error.response ? error.response.status : 500,
      message: "Error fetching indicadores",
    };
  }
};

const asignarIndicadoresProyecto = async (payload) => {
  try {
    const response = await api.post(Endpoint2, payload);
    return {
      status: response.status,
      data: response.data.data, // ajusta según estructura real
    };
  } catch (error) {
    console.error("Error asignando indicadores:", error);
    return {
      status: error.response ? error.response.status : 500,
      message: "Error asignando indicadores",
    };
  }
};

const getIndicadoresAsignadosProyecto = async (oidProyecto) => {
  try {
    const response = await api.get(`${Endpoint3}?oidProyecto=${oidProyecto}`);

    return {
      status: response.status,
      data: response.data.data, // se mantiene consistente con el resto de servicios
    };
  } catch (error) {
    console.error("Error fetching indicadores asignados:", error);
    return {
      status: error.response ? error.response.status : 500,
      message: "Error fetching indicadores asignados",
    };
  }
};

// Obtener avances de indicadores asignados
/**
 * Obtener avances de indicadores asignados a un proyecto
 */
const getAvancesIndicadoresProyecto = async (oidProyecto) => {
  try {
    const response = await api.get(`${Endpoint4}?oidProyecto=${oidProyecto}`);

    return {
      status: response.status,
      data: response.data.data,
    };
  } catch (error) {
    console.error("Error fetching avances:", error);
    return {
      status: error.response ? error.response.status : 500,
      message: "Error fetching avances",
    };
  }
};

// Actualizar avance
/**
 * Actualizar avance de un indicador en un proyecto
 */
const updateAvanceIndicadorProyecto = async (payload) => {
  try {
    const response = await api.put(Endpoint4, payload);

    return {
      status: response.status,
      data: response.data.data,
    };
  } catch (error) {
    console.error("❌ [FRONTEND] Error updating avance:", error);
    return {
      status: error.response ? error.response.status : 500,
      message: "Error updating avance",
    };
  }
};

const deleteIndicator = async (oid) => {
  try {
    const response = await api.delete(`${Endpoint5}/${oid}`);
    return {
      ok: true,
      status: response.status,
      data: response.data.data, // asumiendo que tu API anida el payload en `data.data`
      message: response.data.message, // si tu backend devuelve un mensaje de éxito
    };
  } catch (error) {
    console.error("❌ [FRONTEND] Error deleting indicator:", error);
    const status = error.response?.status || 500;
    const message =
      error.response?.data?.message ||
      error.message ||
      "Error deleting indicator";
    return {
      ok: false,
      status,
      data: null,
      message,
    };
  }
};

const getRepositorioSoportesByProyecto = async (oidProyecto) => {
  try {
    const response = await api.get(`${Endpoint6}?oidProyecto=${oidProyecto}`);

    return {
      status: response.status,
      data: response.data.data, // se mantiene consistente con el resto de servicios
    };
  } catch (error) {
    console.error("Error fetching data:", error);
    return {
      status: error.response ? error.response.status : 500,
      message: "Error fetching data",
    };
  }
};

export {
  getIndicadoresProyectos,
  asignarIndicadoresProyecto,
  getIndicadoresAsignadosProyecto,
  getAvancesIndicadoresProyecto,
  updateAvanceIndicadorProyecto,
  deleteIndicator,
  getRepositorioSoportesByProyecto,
};
